<template>
  <svg
    xmlns="http://www.w3.org/2000/svg" width="18.081"
    height="14.807" viewBox="0 0 18.081 14.807"
  >
    <g data-name="그룹 78">
      <g
        data-name="그룹 65" style="clip-path:url(#gx3w0bfi3a)"
        transform="rotate(-90 7.404 7.404)"
      >
        <path
          data-name="패스 42"
          d="M6.954 10.092.223 4.667A.576.576 0 0 1 0 4.219V.6A.605.605 0 0 1 .4.052a.737.737 0 0 1 .724.1L7.4 5.216 13.683.155a.733.733 0 0 1 .724-.1.606.606 0 0 1 .4.551v3.613a.582.582 0 0 1-.222.448l-6.73 5.424a.733.733 0 0 1-.9 0"
          transform="translate(0 7.834)" style="fill:#e4e4e4"
        />
        <path
          data-name="패스 43"
          d="M6.954 10.092.223 4.667A.576.576 0 0 1 0 4.219V.6A.605.605 0 0 1 .4.052a.737.737 0 0 1 .724.1L7.4 5.216 13.683.155a.733.733 0 0 1 .724-.1.606.606 0 0 1 .4.551v3.613a.582.582 0 0 1-.222.448l-6.73 5.424a.733.733 0 0 1-.9 0"
          style="fill:#e4e4e4"
        />
      </g>
    </g>
  </svg>
</template>